<template>
  <li :class="itemClasses">
    <div :class="tailClasses"></div>
    <div ref="dot" :class="nodeClasses">
      <slot name="dot">
        <i :class="iconClasses"></i>
      </slot>
    </div>
    <div :class="contentClasses">
      <div :class="timeClass" v-html="time"></div>
      <slot name="title">
        <div v-if="title" :class="contentTitleClasses" v-html="title">
        </div>
      </slot>
      <slot>
        <div :class="contentDetailClasses" v-html="detail">
        </div>
      </slot>
    </div>
  </li>
</template>
<script>
const PREFIXCLS = 'timeline__item'

export default {
  name: 'TTimelineItem',
  props: {
    color: {
      type: String,
      default: ''
    },
    time: String,
    title: String,
    detail: {
      type: String
    }
  },
  data() {
    return {
      dot: false
    }
  },
  computed: {
    itemClasses() {
      return `${PREFIXCLS}`
    },
    timeClass() {
      return `${PREFIXCLS}-time`
    },
    tailClasses() {
      return `${PREFIXCLS}-tail`
    },
    iconClasses() {
      return `${PREFIXCLS}-icon`
    },
    nodeClasses() {
      return [
        `${PREFIXCLS}-node`,
        {
          [`${PREFIXCLS}-node--custom`]: this.dot,
          [`${PREFIXCLS}-node--${this.color}`]: this.nodeColorShow
        }
      ]
    },
    nodeColorShow() {
      return ['info', 'danger', 'success', 'warning'].includes(this.color)
    },
    contentClasses() {
      return `${PREFIXCLS}-content`
    },
    contentTitleClasses() {
      return [`${PREFIXCLS}-content-title`, 'mb-2']
    },
    contentDetailClasses() {
      return `${PREFIXCLS}-content-detail`
    }
  },
  mounted() {
    this.dot = !!this.$refs.dot.innerHTML.length
  }
}
</script>



// WEBPACK FOOTER //
// timeline-item.vue?8d243b5e